import type { PrimaryPageAction } from "@octopusdeploy/design-system-components";
import { InlineEmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import type { ChannelResource, ProjectResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
type EphemeralEnvironmentsNoEnvironmentsProps = {
    project: ProjectResource;
    channel: ChannelResource;
};
export function EphemeralEnvironmentsNoEnvironments({ project, channel }: EphemeralEnvironmentsNoEnvironmentsProps) {
    const primaryAction: PrimaryPageAction = {
        label: "Create Release",
        path: links.createReleasePage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug }, { channelId: channel.Id }),
        type: "navigate",
    };
    return (<InlineEmptyStateOnboarding title="Create a release to deploy to your ephemeral environments" description={"Your ephemeral environments are ready! Create a release to test your feature branches while keeping costs down."} actions={{
            primary: primaryAction,
        }} learnMore={{
            label: "Learn more",
            path: "ephemeralenvironments",
        }} illustration={"NoEntities"}/>);
}
